<template>
  <div class="tw:mx-4 tw:lg:mx-0">
    <div class="tw:my-4">
      <Locale />
    </div>
  </div>
</template>
<script setup lang="ts">
import Locale from '@/components/settings/localeSettings/Locale.vue'
</script>
